module.exports = __webpack_public_path__ + "img/music_021.4ffe250d.png";